/* eslint-disable no-console */
import Vue from "vue";
import { register } from "register-service-worker";

if (process.env.NODE_ENV === "production") {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready() {
      Vue.$log.info(
        "App is being served from cache by a service worker.\n" + "For more details, visit https://goo.gl/AFskqB"
      );
    },
    registered() {
      Vue.$log.info("Service worker has been registered.");
    },
    cached() {
      Vue.$log.info("Content has been cached for offline use.");
    },
    updatefound() {
      Vue.$log.info("New content is downloading.");
    },
    updated() {
      Vue.$log.info("New content is available; please refresh.");
    },
    offline() {
      Vue.$log.info("No internet connection found. App is running in offline mode.");
    },
    error(error) {
      console.error("Error during service worker registration:", error);
    }
  });
}
